// Tabs - Simple tab functionality
function initTabs() {
  const tabsComponents = document.querySelectorAll('tabs-component');
  
  tabsComponents.forEach((component) => {
    const navItems = component.querySelectorAll('.tabs__nav-item');
    const panels = component.querySelectorAll('.tabs__panel');
    
    // Show the first tab and hide the rest
    navItems.forEach((item, itemIndex) => {
      if (itemIndex === 0) {
        item.classList.add('tabs__nav-item--active');
      } else {
        item.classList.remove('tabs__nav-item--active');
      }
    });
    
    panels.forEach((panel, panelIndex) => {
      if (panelIndex === 0) {
        panel.classList.add('tabs__panel--active');
        panel.style.display = 'block';
      } else {
        panel.classList.remove('tabs__panel--active');
        panel.style.display = 'none';
      }
    });
    
    // Click function
    navItems.forEach((item) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Remove active class from all nav items
        navItems.forEach(navItem => {
          navItem.classList.remove('tabs__nav-item--active');
        });
        
        // Add active class to clicked item
        this.classList.add('tabs__nav-item--active');
        
        // Hide all panels
        panels.forEach(panel => {
          panel.classList.remove('tabs__panel--active');
          panel.style.display = 'none';
        });
        
        // Show the target panel
        const targetTab = this.dataset.tabTarget;
        const targetPanel = component.querySelector(`[data-tab-panel="${targetTab}"]`);
        if (targetPanel) {
          targetPanel.classList.add('tabs__panel--active');
          targetPanel.style.display = 'block';
        }
        
        return false;
      });
    });
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTabs);
} else {
  initTabs();
}
